import React, { Component } from "react";
import cn from "classnames";
import { FormattedMessage } from "react-intl";

import { aspectRatio as ar } from "../../../../../common/parameters";
import { getTakadimiScore, getTakadimiTypes } from "../../../../../common/helpers/takadimi";
import { getTiriTamTiScore } from "../../../../../common/helpers/kodaly";
import { getAussieScore } from "../../../../../common/helpers/kodalyAussie";
import { getFrenchScore, getFrenchTypes } from "../../../../../common/helpers/frenchSyllables";
import { IBar, INote, IScore } from "../../../../../common/types";
import { RhythmSyllableType } from "../../../../store/user/models";

import player from "../../../../player";
import Icon from "../../../../icon";

import Score from "../../../Score/score-display";

import Wrapper from "../../Wrapper";

import getBirdsPath from "../Common/getBirdsPath";
import MessageDisplay from "../Common/MessageDisplay";
import NotEdited from "../Common/NotEdited";
import getScore from "../Common/getScore";
import getScale from "../Common/getScale";
import getTempo from "../Common/getTempo";
import getBarsOrder from "../Common/getBarsOrder";
import scrollToBar from "../Common/scrollToBar";

import { SubmitButton, PlayBtn, Label, DeleteButton } from "../common-style";

import RhytLadder from "./RhytLadder";
import TakadimiLadder from "./TakadimiLadder";
import FrenchLadder from "./FrenchLadder";
import AussieRhytLadder from "./AussieRhytLadder";
import { ScoreWrapper, RhytLadderWrapper, Asset1Wrapper, Asset2Wrapper, Asset3Wrapper, EasterBackground, ChristmasBackground } from "./styles";
import messages from "./messages";
import { addRhytName, getFirstNoteRhythmName } from "./utils";
import { IProps, IState } from "./interfaces";

const Clock = require("waaclock");

class RhytName extends Component<IProps, IState> {
    static defaultProps = {
        handlePlayCount: () => {},
        handleFailCount: () => {},
    };
    score?: IScore
    takadimiTypes: string[] = []
    gordonTypes: string[] = []
    takatikiTypes: string[] = []
    frenchTypes: string[] = []
    timer?: ReturnType<typeof setTimeout>
    buffers: AudioBufferSourceNode[] = []
    clock: any = undefined;
    distribution?: number[][];
    scoreRef?: HTMLDivElement;
    frame?: HTMLDivElement;
    constructor(props: IProps) {
        super(props);
        this.state = {
            submitable: false,
            submited: false,
            playing: false,
            completed: false,
            checkPlaying: false,
            currentNote: 0,
            solution: [],
            notes: [],
            frameScale: 1,
            incorrectNotes: [[]],
            playingNote: undefined,
            playable: false,
            firstNote: 0,
            rhytNameTypes: {},
        };
        if (props.setReset) {
            props.setReset(this.resetTask);
        }
        if (props.saveState) {
            props.saveState(this.saveState);
        }
        if (props.restoreState) {
            props.restoreState(this.restoreState);
        }
        if (props.showSolution) {
            props.showSolution(this.showSolution);
        }
    }
    resetTask = () => {
        this.setUp();
        this.setState({
            solution: [],
            currentNote: this.state.firstNote,
            submitable: false,
            submited: false,
            completed: false,
        });
    };
    saveState = () => {
        return {
            currentNote: this.state.currentNote,
            submited: this.state.submited,
            solution: this.state.solution,
            incorrectNotes: this.state.incorrectNotes,
            submitable: this.state.submitable,
            completed: this.state.completed,
        };
    };
    restoreState = (state: IState) => {
        this.setState({
            currentNote: state.currentNote,
            submited: state.submited,
            solution: state.solution,
            incorrectNotes: state.incorrectNotes,
            submitable: state.submitable,
            completed: state.completed,
        });
    };
    showSolution = () => {
        const { notes } = this.state;
        this.setState({
            solution: [...notes],
            currentNote: notes.length,
            completed: true,
            submited: true,
        });
    };
    componentDidMount() {
        this.setUp();
        setTimeout(this.setScale);
        window.addEventListener("resize", this.setScale);
    }

    componentWillUnmount() {
        window.removeEventListener("blur", this.blur);
        window.removeEventListener("resize", this.setScale);
        clearTimeout(this.timer);
        if (this.state.playing) {
            this.play();
        }
    }

    setUp() {
        const { task, plan } = this.props;
        const score = getScore(plan, task);
        let firstNote: number | undefined = undefined;
        if (score && score.bars[1] && score.bars[1].notes && score.bars[1].notes.length > 0) {
            this.setState({ playable: true });
            const notes: IState["notes"] = [];
            const rhytNameTypes: IState["rhytNameTypes"] = {};
            score.bars.forEach((bar, barIndex) => {
                if (bar === null) return;
                bar.notes.forEach((note, noteIndex) => {
                    if (note.r) {
                        notes.push({ rest: true, bar: barIndex });
                    } else {
                        if (firstNote === undefined) {
                            firstNote = notes.length;
                        }
                        let newNote: IState["notes"][0] = {
                            l: note.l,
                            bar: barIndex,
                            note: noteIndex,
                        };
                        if (note.d) {
                            newNote.d = true;
                        }
                        addRhytName(rhytNameTypes, newNote, this.props.intl.locale);
                        notes.push(newNote);
                    }
                });
            });
            this.score = JSON.parse(JSON.stringify(score));
            this.takadimiTypes = getTakadimiTypes(score.bars, score.signatures, "taKaDiMi");
            this.gordonTypes = getTakadimiTypes(score.bars, score.signatures, "gordon");
            this.takatikiTypes = getTakadimiTypes(score.bars, score.signatures, "taKaTiKi");
            this.frenchTypes = getFrenchTypes(score.bars, score.signatures);
            this.score!.bars.forEach(bar => {
                if (!bar) return;
                bar.notes.forEach(note => {
                    delete note.p;
                });
            });
            this.score!.settings.upperText = 2;
            this.score!.settings.lowerText = undefined;
            this.score!.settings.lowerText2 = undefined;
            this.setState({ notes, firstNote: firstNote || 0, currentNote: firstNote || 0, rhytNameTypes });
        } else {
            return;
        }
    }

    checkReady = () => {
        const { solution, notes } = this.state;
        let ready = true;
        notes.forEach((note, index) => {
            if (!note.rest) {
                if (!solution[index]) {
                    ready = false;
                }
            }
        });
        if (ready) {
            this.setState({ submitable: true });
        } else {
            this.setState({ submitable: false });
        }
    };

    blur = () => {
        this.play();
    };

    play = async () => {
        const { playing, checkPlaying } = this.state;
        if (playing || checkPlaying) {
            this.buffers.forEach(buffer => {
                buffer.stop();
            });
            this.buffers = [];
            window.removeEventListener("blur", this.blur);
            this.setState({ playing: false, playingNote: undefined, checkPlaying: false });
            this.clock.stop();
            delete this.clock;
            return;
        }
        if (!player.slap) {
            const success = await player.loadSlap();
            if (!success) return this.props.showNotification("Error: Failed to load audio!", "warning");
        }
        window.addEventListener("blur", this.blur);
        let t = 0;
        let late = 0.2;
        this.clock = new Clock(player.context, { toleranceEarly: 0.1 });
        this.clock.start();
        const { task, plan } = this.props;
        this.props.handlePlayCount!();
        let tempo = getTempo(plan, task);
        let lastNote;
        this.buffers = [];
        const barsOrder = getBarsOrder(this.score!);
        const offset = player.context.currentTime + late;
        const points = [];
        let nth = 0;
        const firstNoteOfBars = [];
        for (let b = 0; b < barsOrder.length; b++) {
            let bar = this.score!.bars[barsOrder[b]];
            if (!bar) continue;
            if (firstNoteOfBars[barsOrder[b]] !== undefined) {
                nth = firstNoteOfBars[barsOrder[b]];
            } else {
                firstNoteOfBars[barsOrder[b]] = nth;
            }
            for (let n = 0; n < bar.notes.length; n++) {
                let note = bar.notes[n];
                if (!note.r && (!lastNote || !lastNote.tie)) {
                    let volume = b === 0 ? "forte" : "mezzo";
                    let bufferNode = player.slap!.createNode(volume);
                    bufferNode.start(offset + t);
                    this.buffers.push(bufferNode);
                }
                points.push({
                    time: offset + t,
                    nth,
                    b: barsOrder[b],
                    n,
                });
                lastNote = note;
                nth++;
                t += (4 / note.l) * (60 / tempo) * (note.d ? 1.5 : 1) * (note.t ? 0.67 : 1);
            }
        }
        points.forEach(({ nth, b, n, time }) => {
            this.clock.callbackAtTime(() => {
                this.setState({ playingNote: nth });
                let isScrolling = n === 0;
                if (isScrolling && this.scoreRef) {
                    scrollToBar(this.distribution!, this.scoreRef, b);
                }
            }, time);
        });
        this.clock.callbackAtTime(this.play, offset + t + late);

        this.setState({ playing: true, playingNote: -1 });
    };

    handleInput = (rhytName: { l?: INote["l"], d?: boolean, tiriTamTi?: string, aussie?: string, delete?: boolean }) => {
        let { currentNote, solution, notes, firstNote } = this.state;
        if (rhytName.delete) {
            if (currentNote === 0) return;
            if (!solution[currentNote]) {
                if (currentNote > firstNote) currentNote--;
                while (!notes[currentNote] || (notes[currentNote].rest && currentNote > firstNote)) {
                    currentNote--;
                }
            }
            delete solution[currentNote];
            this.setState({ solution, currentNote, incorrectNotes: [[]], submited: false });
        } else {
            if (!Array.isArray(solution)) {
                solution = [];
            }
            solution[currentNote] = { ...rhytName };
            currentNote++;
            while (notes[currentNote] && notes[currentNote].rest) {
                currentNote++;
            }
            this.setState({ solution, currentNote });
        }
        if (notes[currentNote]) {
            setTimeout(() => {
                scrollToBar(this.distribution!, this.scoreRef!, notes[currentNote].bar);
            }, 500);
        }
        this.checkReady();
    };
    handleTakadimiInput = (rhytName: string) => {
        let { currentNote, solution, notes } = this.state;
        const { user } = this.props;
        if (!Array.isArray(solution)) {
            solution = [];
        }
        if (user.rhythmSyllableType === "gordon") {
            solution[currentNote] = { gordon: rhytName };
        } else if (user.rhythmSyllableType === "taKaTiKi") {
            solution[currentNote] = { takatiki: rhytName };
        } else if (user.rhythmSyllableType === "french") {
            solution[currentNote] = { french: rhytName };
        } else {
            solution[currentNote] = { takadimi: rhytName };
        }
        currentNote++;
        while (notes[currentNote] && notes[currentNote].rest) {
            currentNote++;
        }
        this.setState({ solution, currentNote });
        if (notes[currentNote]) {
            setTimeout(() => {
                scrollToBar(this.distribution!, this.scoreRef!, notes[currentNote].bar);
            }, 500);
        }
        this.checkReady();
    };

    submit = () => {
        const incorrectNotes: number[][] = [[]];
        const { user } = this.props;
        const { rhythmSyllableType = RhythmSyllableType.Kodaly } = user;
        const { solution, notes } = this.state;
        let completed = true;
        const score = this.score!;
        const takadimiSolution =
            rhythmSyllableType === RhythmSyllableType.Takadimi || rhythmSyllableType === RhythmSyllableType.Gordon || rhythmSyllableType === RhythmSyllableType.Takatiki
                ? getTakadimiScore(score.bars, score.signatures, rhythmSyllableType)
                : null;
        const frenchSolution = getFrenchScore(score.bars, score.signatures);
        const tiriTamTiSolution = getTiriTamTiScore(score.bars, rhythmSyllableType === RhythmSyllableType.KodalyTiRiTaiTi);
        const aussieSolution = getAussieScore(score.bars);
        notes.forEach((note, index) => {
            if (!note.rest) {
                if (rhythmSyllableType === RhythmSyllableType.Kodaly || rhythmSyllableType === RhythmSyllableType.KodalyTeTe) {
                    if (note.l !== solution[index]!.l || note.d !== solution[index]!.d) {
                        incorrectNotes[0].push(index);
                        completed = false;
                    }
                } else if (rhythmSyllableType === RhythmSyllableType.KodalyTiRi || rhythmSyllableType === RhythmSyllableType.KodalyTiRiTaiTi) {
                    if (solution[index]!.tiriTamTi !== tiriTamTiSolution[index]) {
                        incorrectNotes[0].push(index);
                        completed = false;
                    }
                } else if (rhythmSyllableType === RhythmSyllableType.Aussie) {
                    if (solution[index]!.aussie !== aussieSolution[index]) {
                        incorrectNotes[0].push(index);
                        completed = false;
                    }
                } else if (rhythmSyllableType === RhythmSyllableType.Takadimi) {
                    if (solution[index]!.takadimi !== takadimiSolution![index]) {
                        incorrectNotes[0].push(index);
                        completed = false;
                    }
                } else if (rhythmSyllableType === RhythmSyllableType.Gordon) {
                    if (solution[index]!.gordon !== takadimiSolution![index]) {
                        incorrectNotes[0].push(index);
                        completed = false;
                    }
                } else if (rhythmSyllableType === RhythmSyllableType.Takatiki) {
                    if (solution[index]!.takatiki !== takadimiSolution![index]) {
                        incorrectNotes[0].push(index);
                        completed = false;
                    }
                } else if (rhythmSyllableType === RhythmSyllableType.French) {
                    if (solution[index]!.french !== frenchSolution[index]) {
                        incorrectNotes[0].push(index);
                        completed = false;
                    }
                }
            }
        });
        if (completed) {
            if (this.props.completed) {
                this.props.completed("rhytName");
            }
        } else {
            this.props.handleFailCount!();
        }

        this.setState({ incorrectNotes, submited: true, completed, currentNote: notes.length });
    };

    setScale = () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            if (!this.frame?.children?.[0]) return;
            let frameWidth = this.frame.children[0].getBoundingClientRect().width;
            let frameScale = frameWidth / ar.width;
            this.setState({ frameScale });
        }, 550);
    };

    selectNote = (bar: number, note: number) => {
        const { notes, completed } = this.state;
        if (completed) return;
        const isRest = this.score!.bars[bar]!.notes[note].r;
        if (isRest) return;
        let currentNote = notes.findIndex(n => n.bar === bar && n.note === note);
        this.setState({
            currentNote,
            submited: false,
            incorrectNotes: [[]],
        });
    };

    setRef = (ref: HTMLDivElement) => {
        this.scoreRef = ref;
    };
    setDistribution = (distribution: number[][]) => {
        this.distribution = distribution;
    };

    render() {
        const {
            incorrectNotes,
            submitable,
            submited,
            playable,
            solution,
            currentNote,
            frameScale,
            playing,
            completed,
            checkPlaying,
            playingNote,
            rhytNameTypes,
            firstNote,
        } = this.state;
        const { task, isLow, isDemo, plan, user, handleHomeworkNext, intl: { locale }, isEaster, isChristmas } = this.props;
        const { data } = task;
        if (!data || !playable)
            return (
                <div ref={e => (this.frame = e!)}>
                    <div>
                        <Wrapper>
                            <NotEdited />
                        </Wrapper>
                    </div>
                </div>
            );
        if (!this.score) return null;
        const scale = getScale(plan, task);
        const firstKnownRhyt = (data.hint && firstNote === currentNote) ? getFirstNoteRhythmName(this.score.bars as IBar[], this.score.signatures[0], user.rhythmSyllableType || RhythmSyllableType.Kodaly, locale) : undefined;
        return (
            <div ref={e => (this.frame = e!)}>
                <Wrapper isDemo={isDemo}>
                    {isLow && (
                        <>
                            <Asset1Wrapper>
                                <img src={getBirdsPath("/rhytName/asset-01.svg")} alt="decoration" />
                            </Asset1Wrapper>
                            <Asset2Wrapper>
                                <img src={getBirdsPath("/rhytName/asset-02.svg")} alt="decoration" />
                            </Asset2Wrapper>
                            <Asset3Wrapper>
                                <img src={getBirdsPath("/rhytName/asset-03.svg")} alt="decoration" />
                            </Asset3Wrapper>
                        </>
                    )}
                    {isEaster && (
                        <EasterBackground />
                    )}
                    {isChristmas && (
                        <ChristmasBackground />
                    )}
                    <ScoreWrapper isLow={isLow} isEaster={isEaster || isChristmas}>
                        <Score
                            score={this.score}
                            rhytName
                            solution={solution}
                            currentNote={!submited ? { note: currentNote, bar: 0 } : undefined}
                            selectNote={this.selectNote}
                            playingNote={playingNote}
                            scale={scale * (isLow ? 0.5425 : (isEaster || isChristmas) ? (1076 / ar.width) : 1)}
                            incorrectNotes={incorrectNotes}
                            themeColor={data.color}
                            whiteBackground={isLow}
                            playing={playing}
                            setRef={this.setRef}
                            setDistribution={this.setDistribution}
                            isEaster={isEaster || isChristmas}
                        />
                    </ScoreWrapper>
                    <RhytLadderWrapper className={cn(completed && "Completed")}>
                        {user.rhythmSyllableType === RhythmSyllableType.Takadimi ||
                        user.rhythmSyllableType === RhythmSyllableType.Gordon ||
                        user.rhythmSyllableType === RhythmSyllableType.Takatiki ? (
                            <TakadimiLadder
                                handleInput={this.handleTakadimiInput}
                                takadimiTypes={this.takadimiTypes}
                                takatikiTypes={this.takatikiTypes}
                                gordonTypes={this.gordonTypes}
                                isLow={!!isLow}
                                isGordon={user.rhythmSyllableType === RhythmSyllableType.Gordon}
                                isTaKaTiKi={user.rhythmSyllableType === RhythmSyllableType.Takatiki}
                                firstKnownRhyt={firstKnownRhyt}
                            />
                        ) : user.rhythmSyllableType === RhythmSyllableType.French ? (
                            <FrenchLadder
                                frameScale={frameScale}
                                handleInput={this.handleTakadimiInput}
                                rhytNameTypes={this.frenchTypes}
                                isLow={!!isLow}
                                firstKnownRhyt={firstKnownRhyt}
                            />
                        ) : user.rhythmSyllableType === RhythmSyllableType.Aussie ? (
                            <AussieRhytLadder
                                frameScale={frameScale}
                                handleInput={this.handleInput}
                                rhytNameTypes={rhytNameTypes}
                                isLow={!!isLow}
                                locale={locale}
                                firstKnownRhyt={firstKnownRhyt}
                            />
                        ) : (
                            <RhytLadder
                                frameScale={frameScale}
                                handleInput={this.handleInput}
                                isTiriTamTi={user.rhythmSyllableType === RhythmSyllableType.KodalyTiRi}
                                isTiriTaiTi={user.rhythmSyllableType === RhythmSyllableType.KodalyTiRiTaiTi}
                                isTeteTamTi={user.rhythmSyllableType === RhythmSyllableType.KodalyTeTe}
                                rhytNameTypes={rhytNameTypes}
                                isLow={!!isLow}
                                locale={locale}
                                firstKnownRhyt={firstKnownRhyt}
                            />
                        )}
                    </RhytLadderWrapper>
                    <PlayBtn
                        isEaster={isEaster}
                        className={cn("button", "button--play")}
                        onClick={() => this.play()}
                        disabled={checkPlaying}
                        isLow={isLow}
                    >
                        {playing ? <Icon i="stop" /> : <Icon i="play" />}
                        <Label>
                            <FormattedMessage {...messages.play} />
                        </Label>
                    </PlayBtn>
                    {!completed && (
                        <DeleteButton
                            style={{
                                top: isLow ? 30 : 5,
                                right: isLow ? 30 : 5,
                                bottom: "auto",
                                left: "auto",
                                padding: 16,
                                paddingBottom: 5,
                                paddingTop: 5,
                                width: "auto",
                            }}
                            isEaster={isEaster}
                            className={cn("button button--info")}
                            onClick={() => {
                                this.handleInput({ delete: true });
                            }}
                            isLow={isLow}
                        >
                            <FormattedMessage {...messages.delete} />
                        </DeleteButton>
                    )}
                    {submitable && !completed && !submited && (
                        <SubmitButton
                            isLow={isLow}
                            isEaster={isEaster}
                            style={{
                                top: isLow ? 30 : 6,
                                bottom: "auto",
                                right: 540,
                                left: "auto",
                                paddingBottom: 5,
                                paddingTop: 5,
                            }}
                            className={cn("button")}
                            onClick={() => {
                                if (submitable) {
                                    this.submit();
                                }
                            }}
                        >
                            <FormattedMessage {...messages.submit} />
                        </SubmitButton>
                    )}
                    {completed && (
                        <MessageDisplay isChristmas={isChristmas} isLow={!!isLow} type="completed" handleHomeworkNext={handleHomeworkNext} />
                    )}
                    {submited && !completed && <MessageDisplay isChristmas={isChristmas} isLow={!!isLow} type="incorrect" />}
                </Wrapper>
            </div>
        );
    }
}

export default RhytName;
